import { IEntity } from "@interfaces/entity";
import { Customer } from "./customer";

export class Operator implements IEntity{
  id: number;
  name: string;

  customers: Customer[];

  entityName = "Operator";

  constructor(formValue?: Partial<Operator>) {
    Object.assign(this, formValue);
  }

  updateValues(formValue: Partial<Operator>) {
    Object.assign(this, formValue);
  }

  getPrimaryKey() {
    return this.id;
  }
}
